module.exports = __webpack_public_path__ + "img/g0136.76937744.png";